<template>
  <div class="basic_wrap">
    <colorHeader :showback="false" :radius="false" :kefu="true" :title="$t('home.item')"/>
    <div class="item_wrap">
      <div class="tabs">
        <van-tabs v-model="active" @click="sort" >
          <van-tab v-for="index in tabs" :title="index.title" :name="index.name"></van-tab>
        </van-tabs>
        <van-empty v-if="listLength == 0" :description="$t('item.noData')"/>
      </div>
      <div class="items_3 item_margin">
        <div v-for="i in data.list" :key="i.id" class="item">
          <div class="item_div1" @click="$router.push('/item/'+i.id)">

            <p>
              {{ i[lang] }}
            </p>
          </div>
          <div v-if="showcover"  @click="$router.push('/item/'+i.id)" :style="'background-image:url('+i.img+');background-size:cover;width:100%;height:150px;margin-top:0px;'"></div>

          <div class="item_div2" @click="$router.push('/item/'+i.id)">
            <div class="item_rate">
              <p>{{i.rate}}%</p>
              <p>{{$t('utils.dailyIncome')}}</p>
            </div>
            <div class="item_day">
              <p>{{i.day}}{{$t('utils.day')}}</p>
              <p>{{$t('utils.cycle')}}</p>
            </div>
            <div class="item_min">
              <p>{{i.min}}{{utils_moneyMark()}}</p>
              <p>{{$t('utils.startingAmount')}}</p>
            </div>
          </div>
          <div class="item_div3">
            <span>{{$t('utils.scale')}}:{{i.total}}{{utils_moneyMark()}}</span>
            <!-- <span>   按日收益，到期还本</span> -->
          </div>
          <div class="item_div4">
            <van-progress :percentage="i.percent"/>
            <div class="item_btn">
              <button v-if="i.percent<100" type="button" @click="buy(i)">{{$t('utils.invest')}}</button>
              <button v-if="i.percent>=100" class="item_btn_over" type="button">{{$t('utils.investOver')}}</button>
            </div>
          </div>
        </div>
      </div>
      <van-dialog
          v-model="show_tz"
          show-cancel-button
          @confirm="confirm"
          :confirmButtonText="$t('utils.confirm')"
          :cancelButtonText="$t('utils.cancel')"
      >
        <div class="items_3">
          <div class="item">
            <div class="item_div1">
              <p>
                {{ sku[lang] }}
              </p>
              <!-- <p>每日可赚100.00</p> -->
            </div>
            <div class="item_div2">
              <div class="item_rate">
                <p>{{sku.rate}}%</p>
                <p>{{$t('utils.dailyIncome')}}</p>
              </div>
              <div class="item_day">
                <p>{{sku.day}}{{$t('utils.day')}}</p>
                <p>{{$t('utils.cycle')}}</p>
              </div>
              <div class="item_min">
                <p>{{sku.min}}{{utils_moneyMark()}}</p>
                <p>{{$t('utils.startingAmount')}}</p>
              </div>
            </div>
          </div>
        </div>
        <van-field v-model="number" type="number" :placeholder="$t('item.inputAmount')"/>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import Fetch from '../../utils/fetch';
import Vue from 'vue';
import {Tab, Tabs, Progress, Empty, Dialog, Field} from 'vant';

Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field);
export default {
  name: "item",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      tabs: [
        {name:0,title:this.$t('item.all')}
      ],
      active: 0,
      data: [],
      listLength: 0,
      show_tz: false,
      number: "",
      sku: []
    }
  },
  created() {
    this.$parent.footer('item');
  },
  mounted() {
    var type = 0;
    if (this.$router.history.current.query.type) {
      this.active = parseInt(this.$router.history.current.query.type);
      type = this.$router.history.current.query.type;
    }
    this.start(type);
  },
  methods: {
    start(type) {
      Fetch('/index/item_search', {
        name: "",
        cate: type
      }).then(r => {
        this.data = r.data;
        this.tabs = [{name:'0',title:this.$t('item.all')}].concat(r.data.cates);
        this.listLength = r.data.list.length;
      })
    },
    sort(type) {
      this.start(type);
    },
    buy(item) {
      this.sku = item;
      this.show_tz = true;
    },
    confirm() {
      if (!this.number) {
        this.$toast(this.$t('item.inputAmount'));
        return false;
      }
      Fetch("/index/item_apply", {
        id: this.sku.id,
        money: this.number
      }).then(r => {
        this.$router.push("/order");
      }).catch(err => {
        // this.psd_val = '';
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-cell {
  padding: 15px 26px;
}

.red_top_bg {
  position: fixed;
  top: 0;
  z-index: 10;
  height: 64px;
  line-height: 64px;
  background: -webkit-linear-gradient(left,#00e6ff,#6439e1);
	background: linear-gradient(90deg,#00e6ff,#6439e1);
  .big_tit{
    top:24px
  }
}

.basic_wrap {
  position: relative;
  padding-bottom: 100px;
}

.item_wrap {
  width: 100%;

  .tabs {
    max-width: 750px;
    position: fixed;
    z-index: 100;
    width: 100%;
  }
}

.item_margin {
  padding-top: 48px;
}

.items_3 {
  width: 96%;
  margin: 0 auto;
  .item {
    background: #FFFFFF;
  }
}

.items_3 {
  .item {
    margin-bottom: 10px;

    div {
      margin: 5px 0;
    }

    .item_div1 {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ECECEC;
      padding: 15px 10px;

      p:nth-child(1) {
        // width: 90%;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_div2 {
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 14px;

      div {
        width: 33.33%;

        p {
          padding: 5px 0;
        }
      }

      .item_rate {
        p:nth-child(1) {
          font-weight: bold;
          color: #FF0000;

        }

        p:nth-child(2) {
          color: #999;
        }
      }

      .item_day {
        p:nth-child(1) {
          font-weight: bold;
        }

        p:nth-child(2) {
          color: #999;
        }
      }

      .item_min {
        p:nth-child(1) {
          font-weight: bold;

        }

        p:nth-child(2) {
          color: #999;
        }
      }
    }

    .item_div3 {
      color: #999;
      padding: 5px 10px;
    }

    .item_div4 {
      padding: 5px 10px;
      display: flex;
      justify-content: space-between;

      div:nth-child(1) {
        width: 75%;
        margin-top: 16px;
      }

      .item_btn {
        width: 20%;

        button {
          min-width: 60px;
          color: #1989fa;
          padding: 5px 5px;
          border-radius: 5px;
          border: 1px solid #1989fa;
        }

        .item_btn_over {
          color: #999;
          border: 1px solid #999;
        }
      }
    }
  }
}

/deep/ .van-tabs__line {
  height: 2px;
  background-color: #1989fa;
}

/deep/ .van-tab--active {
  color: #1989fa;
}
/deep/ .van-tab{
  -webkit-box-flex: 1;
  -webkit-flex: 1 0 auto;
  flex: 1 0 auto;
}
</style>
